import Vue from 'vue';
import store from '@/store'
import router from '@/router';

// TailwindCSS
import '@/css/index.css';

// Vuetify
import vuetify from '@/plugins/vuetify'; // path to vuetify export

import App from '@/App.vue';

Vue.config.productionTip = false;

const DEFAULT_TITLE = store.state.globals.title;
router.afterEach((to, from) => {
  // Using `from` to bypass linting error
  from
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

new Vue({
	render: h => h(App),
	store,
	router,
	vuetify,
}).$mount('#app');
